export default __webpack_public_path__ + "static/media/reset-pass-illustration.ef2ec404.svg";